// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

// import 'jquery'
// import 'bootstrap'

// <!-- Bootstrap core CSS -->
import '@/assets/css/bootstrap.min.css'

// <!-- Custom styles for this template -->
import '@/assets/css/custom-style.css'
import '@/assets/css/responsive.css'

// <!-- Bootstrap core JavaScript
import '@/assets/js/jquery-3.1.1.min.js'
import '@/assets/js/bootstrap.min.js'
// import '@/assets/js/bootstrap-select.min.js'
import '@/assets/js/jquery.slicknav.min.js'
import '@/assets/js/jquery.countTo.min.js'
import '@/assets/js/jquery.shuffle.min.js'
import '@/assets/js/script.js'
import '@/assets/js/easing.min.js'

// Contact Javascript File
import '@/assets/mail/jqBootstrapValidation.min.js'

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js